import React from 'react';
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalHeaderTitle,
  CloseButton,
  ModalBody,
} from '../styles/ModalStyles.js';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import { Box, Button, Typography } from '@mui/material';

const ErrorModal = ({
  isOpen,
  onClose,
  statusCode,
  errorMessage,
  onRetry = null
}) => {
  if (!isOpen) return null;

  const getErrorTitle = (statusCode) => {
    if (statusCode >= 500) return 'Server Error';
    if (statusCode === 404) return 'Not Found';
    if (statusCode === 403) return 'Access Denied';
    if (statusCode === 401) return 'Unauthorized';
    if (statusCode >= 400) return 'Error';
    return 'Error';
  };

  const getErrorColor = (statusCode) => {
    if (statusCode >= 500) return '#d32f2f'; // Red
    if (statusCode === 404) return '#f57c00'; // Orange
    if (statusCode === 403) return '#f57c00'; // Orange
    if (statusCode === 401) return '#f57c00'; // Orange
    if (statusCode >= 400) return '#f57c00'; // Orange
    return '#7522D1'; // Primary color
  };

  const errorColor = getErrorColor(statusCode);
  const errorTitle = getErrorTitle(statusCode);

  const displayMessage = errorMessage || 'Something went wrong';

  return (
    <ModalOverlay>
      <ModalContainer sx={{ maxWidth: 450, width: '90%' }}>
        <ModalHeader>
          <ModalHeaderTitle sx={{ color: errorColor, fontWeight: 700, letterSpacing: '0.5px' }}>
            {errorTitle}
          </ModalHeaderTitle>
          <CloseButton onClick={onClose} sx={{ color: 'rgba(0,0,0,0.5)' }}>
            <CloseIcon />
          </CloseButton>
        </ModalHeader>

        <ModalBody sx={{ p: 4, textAlign: 'center' }}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
            animation: 'shake 0.5s ease-in-out'
          }}>
            <ErrorIcon sx={{
              fontSize: 70,
              color: errorColor,
              filter: `drop-shadow(0 4px 10px ${errorColor}33)`
            }} />
          </Box>

          <Typography variant="h6" sx={{
            fontWeight: 600,
            mb: 1.5,
            color: '#1a1a1a'
          }}>
            {displayMessage}
          </Typography>

          <Typography variant="body2" sx={{
            color: 'text.secondary',
            mb: 4,
            lineHeight: 1.6
          }}>
            {statusCode === 401
              ? 'Please check your credentials and try again.'
              : 'Please check the provided information and try again.'}
          </Typography>



          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              fullWidth
              onClick={onRetry || onClose}
              sx={{
                py: 1.2,
                borderRadius: '10px',
                fontSize: '1rem',
                fontWeight: 600,
                textTransform: 'none',
                backgroundColor: statusCode >= 500 ? '#d32f2f' : '#7522D1',
                boxShadow: `0 4px 12px ${statusCode >= 500 ? '#d32f2f33' : '#7522D133'}`,
                '&:hover': {
                  backgroundColor: statusCode >= 500 ? '#b71c1c' : '#5a1aa0',
                  transform: 'translateY(-1px)'
                },
                transition: 'all 0.2s ease'
              }}
            >
              {onRetry ? 'Try Again' : 'Close'}
            </Button>
          </Box>
        </ModalBody>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default ErrorModal;
